import React from 'react'
import {Icon} from '@chakra-ui/react'
const CloseIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" cursor="pointer" fill="transparent" {...props}>
            <rect
                x="7.18555"
                y="30.7539"
                width="33.3333"
                height="3"
                transform="rotate(-45 7.18555 30.7539)"
                fill="currentColor"
            />
            <rect
                x="7.18359"
                y="9.24609"
                width="3"
                height="33.3333"
                transform="rotate(-45 7.18359 9.24609)"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CloseIcon
